<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="header-left">
      <button mat-icon-button (click)="back()" matTooltip="Back to portal">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <h2>Directors Database</h2>
    </div>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
    </div>
  </div>
  <app-director-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    [fieldsConfig]="searchFieldsConfig"
    (directorSearchFilter)="onDirectorSearchFilterChange($event)"
    (showBoardMembershipsChange)="showBoardMemberships = $event">
  </app-director-search-box>
  <app-generic-list
    [items]="directors"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [currentPage]="currentPage - 1"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [enableMatching]="false"
    [enableEdit]="false"
    [enableDelete]="false"
    [enableView]="true"
    [sortActive]="sortBy"
    [sortDirection]="ascending ? 'asc' : 'desc'"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (viewClick)="onViewDirector($event)">
  </app-generic-list>
</div>
